module.exports = __webpack_public_path__ + "media/images/illustrations/half-circle-e3156472270dc71804db82dcbc69cfd9.png";